import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import { Asr, Home, Ocr } from './views'

import Routes from './Routes'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import { SpeechProvider } from './contexts/SpeechContext'
import { LocalStorageProvider, useLocalStorage } from './contexts/LocalStorageContext'

const version = '0.1.0'

const App = () => {
  return (
    <LocalStorageProvider>
      <SpeechProvider>
        <Router>
          <div style={{ position: 'absolute', width: '100vw', height: '100vh', overflowX: 'hidden', overflowY: 'auto', background: 'linear-gradient(135deg, #e0f7ff, #a0cfff)' }}>
            <Routes />
          </div>
        </Router>
      </SpeechProvider>
    </LocalStorageProvider>
  )
}

export default App
